<template>
  <div>
    <div class="area">
      <div class="left">
        <el-select v-model="queryString.city" placeholder="请选择城市" style="width:120px" @change="cityChange">
          <el-option v-for="(item,index) in citys" :key="index" :label="item.city" :value="item.city"></el-option>
        </el-select>

        <el-select v-model="queryString.postId" placeholder="请选择驿站" clearable="">
          <el-option v-for="(item,index) in cityPost" :key="index" :label="item.postStation"
                     :value="item.postStationId"></el-option>
        </el-select>

        <el-button type="primary" icon="el-icon-refresh" @click="BtnRefresh">刷新</el-button>
      </div>
    </div>
    <div class="area">
      <div class="left3">
        <span class="title">站点工作台</span>
        <div class="items">
          <div class="item">
            <div class="title"><i class="el-icon-collection-tag" style="margin-right:5px"></i>服务订单</div>
            <div class="field">
              <div class="label">今日待服务</div>
              <div class="value">{{ filterDailyItem("今日待服务") }}</div>
            </div>
            <div class="field">
              <div class="label">挂单</div>
              <div class="value">{{ filterDailyItem("挂单") }}</div>
            </div>
            <div class="field">
              <div class="label">可邀约好评</div>
              <div class="value">{{ filterDailyItem("可邀约好评") }}</div>
            </div>
            <div class="field">
              <div class="label">今日保洁新客</div>
              <div class="value">{{ filterDailyItem("今日保洁新客") }}</div>
            </div>
            <div class="field">
              <div class="label">今日品类新客</div>
              <div class="value">{{ filterDailyItem("今日品类新客") }}</div>
            </div>
          </div>

          <div class="item">
            <div class="title"><i class="el-icon-collection-tag" style="margin-right:5px"></i>招商管理</div>
            <div class="field">
              <div class="label">线索</div>
              <div class="value">{{ filterDailyItem("线索") }}</div>
            </div>
            <div class="field">
              <div class="label">培训中</div>
              <div class="value">{{ filterDailyItem("培训中") }}</div>
            </div>
            <div class="field">
              <div class="label">跟单中</div>
              <div class="value">{{ filterDailyItem("跟单中") }}</div>
            </div>
            <div class="field">
              <div class="label">待上线</div>
              <div class="value">{{ filterDailyItem("待上线") }}</div>
            </div>
          </div>

          <div class="item">
            <div class="title"><i class="el-icon-collection-tag" style="margin-right:5px"></i>日常管理</div>
            <div class="field">
              <div class="label">请假申请</div>
              <div class="value">{{ filterDailyItem("请假申请") }}</div>
            </div>
            <div class="field">
              <div class="label">待处理工单</div>
              <div class="value">{{ filterDailyItem("待处理工单") }}</div>
            </div>
            <div class="field">
              <div class="label">投诉工单</div>
              <div class="value">{{ filterDailyItem("投诉工单") }}</div>
            </div>
            <div class="field">
              <div class="label">报备工单</div>
              <div class="value">{{ filterDailyItem("报备工单") }}</div>
            </div>
          </div>

          <div class="item">
            <div class="title"><i class="el-icon-collection-tag" style="margin-right:5px"></i>物料管理</div>
            <div class="field">
              <div class="label">待处理订单</div>
              <div class="value">{{ filterDailyItem("待处理订单") }}</div>
            </div>
            <div class="field">
              <div class="label">物料库存预警</div>
              <div class="value">{{ filterDailyItem("物料库存预警") }}</div>
            </div>
            <div class="field">
              <div class="label">今日待发放</div>
              <div class="value">{{ filterDailyItem("今日待发放") }}</div>
            </div>
            <div class="field">
              <div class="label">盘库中</div>
              <div class="value">{{ filterDailyItem("盘库中") }}</div>
            </div>

          </div>

          <div class="item border_hiddle">
            <div class="title"><i class="el-icon-collection-tag" style="margin-right:5px"></i>异常关注</div>
            <div class="field">
              <div class="label">潜在流失</div>
              <div class="value">0</div>
            </div>
            <div class="field">
              <div class="label">低忠诚度</div>
              <div class="value">0</div>
            </div>
            <div class="field">
              <div class="label">指标预警</div>
              <div class="value">0</div>
            </div>
          </div>

        </div>
      </div>

      <div class="right">
        <span class="title">实时站点</span>
        <span class="time font12">{{ daily.length > 0 ? daily[0].createTime : '未更新' }}</span>
        <div class="items">
          <div class="item border_hiddle">
            <CircleProgress :id="1" :widthPresent="0.5" :radius="12" style="height:unset" :isRound="true" :progress="67"
                            :isAnimation="true">
              <div class="pie_content">
                <span class="bold">65分</span>
                <span class="font12">+10% </span>
                <span class="font12">对比昨天</span>
              </div>
            </CircleProgress>
            <div class="desc">服务者人群<br/>综合健康指数
              <i class="el-icon-question"></i>
            </div>
          </div>
          <div class="item border_hiddle center">
            <div>
              <div class="stock">
                <div>{{ stock7[0] }}</div>
                <div>{{ stock7[1] }}</div>
                <div>%</div>
              </div>
              <div style="margin-top:5px;text-align: center;margin-bottom: 10px;" class="font12">未来7天库存率</div>
            </div>
            <div>
              <div class="stock">
                <div>{{ stock14[0] }}</div>
                <div>{{ stock14[1] }}</div>
                <div>%</div>
              </div>
              <div style="margin-top:5px;text-align: center;" class="font12">未来14天库存率</div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="area">
      <div class="left" style="padding-top:10px">
        <div class="items">
          <div class="item ">
            <div class="title" style="text-align:left">服务指标数据</div>
            <div class="flex_row">
              <div v-for="(item,index) in serviceRebuy.filter((s)=>{return s.label=='服务指标数据'})" :key="index">
                <div class="field center">
                  <div class="valueC">{{ item.value }}</div>
                  <div class="labelC">{{ item.name }}</div>
                </div>
              </div>
              <!-- <div class="field center">
                <div class="valueC">90%</div>
                <div class="labelC">服务准时率</div>
              </div>
              <div class="field center">
                <div class="valueC">5%</div>
                <div class="labelC">问题订单率</div>
              </div>

              <div class="field center">
                <div class="valueC">5%</div>
                <div class="labelC">订单差评率</div>
              </div>
              <div class="field center">
                <div class="valueC">5%</div>
                <div class="labelC">新人差评率</div>
              </div>
              <div class="field center">
                <div class="valueC">5%</div>
                <div class="labelC">老人差评率</div>
              </div> -->
            </div>
          </div>

          <div class="item border_hiddle">
            <div class="flex_row_between">
              <span class="title">复购指标数据</span>
              <div class="flex_row">
                <div class="flex_row center">
                  <div class="font12">选择年月</div>
                  <el-date-picker v-model="listQueryServiceRebuy.month" style="width:110px;margin-left:5px" type="month"
                                  value-format="yyyy-MM" @change="getStationServiceRebuy"></el-date-picker>
                </div>
              </div>
            </div>
            <div class="flex_row">
              <div v-for="(item,index) in serviceRebuy.filter((s)=>{return s.label=='复购指标数据'})" :key="index">
                <div class="field center">
                  <div class="valueC">{{ item.value }}</div>
                  <div class="labelC">{{ item.name }}</div>
                </div>
              </div>

              <!-- <div class="field center">
                <div class="valueC">90%</div>
                <div class="labelC">30天复用率</div>
              </div>
              <div class="field center">
                <div class="valueC">5%</div>
                <div class="labelC">90天留存率</div>
              </div>
              <div class="field center">
                <div class="valueC">5%</div>
                <div class="labelC">新客履约7天转周期</div>
              </div>
              <div class="field center">
                <div class="valueC">5%</div>
                <div class="labelC">保洁新客复购率</div>
              </div>
              <div class="field center">
                <div class="valueC">5%</div>
                <div class="labelC">周期续约率</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="area">
      <div class="left">
        <div class="items">
          <div class="item border_hiddle">
            <div class="flex_row_between">
              <span class="title">库存看板</span>
              <div class="flex_row">
                <div class="flex_row center">
                  <div class="font14_b_mr">{{ calendarMonth }}</div>
                  <i class="el-icon-arrow-left" @click="preMonth" style="border:1px solid #d2c9c9"></i>
                  <i class="el-icon-arrow-right" @click="nextMonth" style="border:1px solid #d2c9c9"></i>
                </div>
              </div>
            </div>
            <div class="flex_row">
              <div class="sche_board" v-for="(item,index) in tradesInfo" :key="index">
                <div class="labelC">{{ item.name }}</div>
                <div class="valueC">{{ item.value }}</div>
                <!-- <div class="question">?</div> -->
              </div>

            </div>
            <!-- 日志看板 -->
            <el-calendar v-model="calendarDate">
              <template slot="dateCell" slot-scope="{date, data}">
                <div :class="{'sche_cell_over':currDate>data.day.split('-').slice(1).join('-')}"
                     @click="calendarClick(data.day)">
                  <div :class="{'sche_title':1==1}">{{ formatSchDate(data.day) }}</div>
                  <div style="margin-top:10px">
                    <div :class="{'sche_cell_title':1==1}">
                      <span>时段</span>
                      <span>{{ filterDate(data.day.split('-').slice(1).join('-')) }}</span>
                      <span>挂单</span>
                    </div>
                    <div v-for="(item,index) in trades" :key="index">
                      <div class="sche_cell" v-if="data.day.split('-').slice(1).join('-')==item.date">
                        <span>{{ item.timeQuantum }}</span>
                        <span>{{ item.trades }}单</span>
                        <span>{{ item.suspend }}单</span>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </el-calendar>
          </div>
        </div>
      </div>
      <div class="right">
        <div class="items">
          <div class="item border_hiddle">
            <div class="title" style="text-align:left">本站光荣榜</div>
            <div style="border-left:5px solid #09afff;margin:30px 5px;padding-left:5px">服务费排名</div>
            <div v-for="(item,index) in filterHonour('光荣榜-服务费排名')" :key="item.name">
              <div class="salary">
                <img :src="require('@/assets/top'+(index+1)+'.png')"/>
                <div>
                  <div class="flex_row_between">
                    <span>NO.{{ index + 1 }} {{ item.name }}</span>
                    <span>{{ item.value }}元</span>
                  </div>
                  <div class="line"></div>
                </div>
              </div>
            </div>

            <div style="border-left:5px solid #09afff;margin:30px 5px;padding-left:5px">复购排名</div>
            <div v-for="(item,index) in filterHonour('光荣榜-复购排名')" :key="item.name">
              <div class="salary">
                <img :src="require('@/assets/top'+(index+1)+'.png')"/>
                <div>
                  <div class="flex_row_between">
                    <span>NO.{{ index + 1 }} {{ item.name }}</span>
                    <span>{{ item.value }}元</span>
                  </div>
                  <div class="line"></div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- 综合得分列表 -->
    <div>
      <el-row>
        <el-input type="search" placeholder="请输入名字搜索" v-model="searchName" style="width:150px;margin-top:10px;">
          搜索
        </el-input>
        <el-button type="search" @click="queryWorkerDetail">搜索</el-button>
        <el-table @sort-change="sortChange" :data="listData" border style="width: 100%" class="table">
          <el-table-column type="index" label="序号" width="55"></el-table-column>
          <el-table-column prop="worker_name" label="姓名" width="80">
            <template slot-scope="scope">
              <a style="color:#52c0fe;cursor:pointer;" @click="go360(scope.row)">{{ scope.row.worker_name }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="city" label="城市" width="80"></el-table-column>
          <el-table-column prop="post_station" label="驿站"></el-table-column>
          <el-table-column prop="station" label="服务站"></el-table-column>
          <el-table-column prop="cancel_time" label="解约状态">
            <template slot-scope="scope">
              <span>{{ (scope.row.cancel_time == null || scope.row.cancel_time == '') ? '在职' : '解约' }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="total_score" label="综合得分" sortable>
            <template slot-scope="scope">
              <span>{{ scope.row.total_score }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="work_days_score" label="上线时长" sortable>
            <template slot-scope="scope">
              <span>{{ scope.row.work_days_score * 100 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="rebuy_score" label="复购" sortable>
            <template slot-scope="scope">
              <span>{{ scope.row.rebuy_score * 100 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="good_rate_score" label="好评率" sortable>
            <template slot-scope="scope">
              <span>{{ scope.row.good_rate_score * 100 }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="salary_score" label="薪资" sortable>
            <template slot-scope="scope">
              <span>{{ scope.row.salary_score * 100 }}</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <pagination :total="total" :page.sync="currentPage" :limit.sync="pageSize" @pagination="queryWorkerDetail"/>

      </el-row>

    </div>
    <!-- 点击每日工单 查看工单明细 -->
    <el-dialog title="日工单明细" :visible.sync="dialogTradeFormVisible" width="1050px">
      <el-tabs v-model="tradeTab" @tab-click="handleTradeTabClick">
        <el-tab-pane label="服务工单" name="first">
          <el-table :data="tradeListByDay" border style="width: 100%" class="table">
            <el-table-column prop="bookTradeNo" label="服务工单编号"></el-table-column>
            <el-table-column prop="itemName" label="服务项"></el-table-column>
            <el-table-column prop="bookTime" label="预约时间" width="200px"></el-table-column>
            <el-table-column prop="servantName" label="服务人员"></el-table-column>
            <el-table-column prop="status" label="工单状态"></el-table-column>
            <el-table-column prop="isBjFirst" label="是否为保洁首单">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isBjFirst==1?'success':''">
                  {{ scope.row.isBjFirst == 1 ? '是' : '否' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="isPlFirst" label="是否为品类首单">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isPlFirst==1?'success':''">
                  {{ scope.row.isPlFirst == 1 ? '是' : '否' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column prop="createTime" label="更新时间"></el-table-column>
          </el-table>

          <!-- 分页 -->
          <pagination :total="listQueryTrade.total" :page.sync="listQueryTrade.pageIndex"
                      :limit.sync="listQueryTrade.pageSize" @pagination="queryTradeByDay"/>
        </el-tab-pane>
        <el-tab-pane label="挂单" name="second">
          <el-table :data="suspendListByDay" border style="width: 100%" class="table">
            <el-table-column prop="bookTradeNo" label="服务工单编号"></el-table-column>
            <el-table-column prop="itemName" label="服务项"></el-table-column>
            <el-table-column prop="bookTime" label="预约时间" width="200px"></el-table-column>
            <el-table-column prop="createTime" label="更新时间"></el-table-column>
          </el-table>

          <!-- 分页 -->
          <pagination :total="listQuerySuspend.total" :page.sync="listQuerySuspend.pageIndex"
                      :limit.sync="listQuerySuspend.pageSize" @pagination="querySuspendByDay"/>
        </el-tab-pane>
        <el-tab-pane label="服务人员" name="third"/>
      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogTradeFormVisible = false">确定</el-button>
      </div>
    </el-dialog>
  </div>

</template>


<script>
import moment from "moment";
import CircleProgress from "vue-circleprogressbar";
import workercrmapi from "@/script/api/workercrmapi";
import {formatDate} from "@/script/api/date";
import globalData from "@/components/common/globaldata/global.data.vue";
import pagination from "@/components/common/Pagination";
import {validateIdNo} from "@/script/validator";

let vm;
export default {
  components: {CircleProgress, pagination},
  filters: {
    filterHonour(label) {
      return this.honour.map((i) => {
        return i.label == label;
      });
    },
  },
  data() {
    return {
      searchName: "",
      calendarDate: new Date(),
      calendarMonth: formatDate(new Date(), "yyyy-MM"),
      currDate: formatDate(new Date(), "MM-dd"),
      queryString: {
        city: "上海",
        month: "",
        postId: 0,
      },
      citys: [],
      cityPost: [],
      postStation: [],
      station: "",
      trades: "", //日历数据
      tradesInfo: "", //日历库存看板汇总信息
      honour: [], //光荣榜
      daily: [], //站长工作台 日常内容
      stock7: [0, 0], //七日库存
      stock14: [0, 0], //14日库存
      dialogTradeFormVisible: false, //每日工单明细
      tradeTab: "first",
      tradeListByDay: [], //每日工单
      serviceRebuy: [], //复购指标数据
      listQueryServiceRebuy: {
        city: "",
        postId: 0,
        month: formatDate(new Date(), "yyyy-MM"),
      },
      listQueryTrade: {
        city: "",
        date: "",
        total: 0,
        pageIndex: 0,
        pageSize: 20,
      },
      suspendListByDay: [], //每日挂起
      listQuerySuspend: {
        city: "",
        date: "",
        total: 0,
        pageIndex: 0,
        pageSize: 20,
      },
      listData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
    };
  },
  created() {
    this.getStationDashboardDaily();
    this.getPostStationList();
    this.getStationServiceRebuy();
    this.queryWorkerDetail();
  },
  mounted() {
    this.$nextTick(() => {
      // 点击前一个月
      let prevBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(1)"
      );
      prevBtn.addEventListener("click", () => {
        this.judgeDate(this.calendarDate);
      });
      let dayBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(2)"
      );
      dayBtn.addEventListener("click", () => {
        this.judgeDate(this.calendarDate);
      });
      let nextBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(3)"
      );
      nextBtn.addEventListener("click", () => {
        this.judgeDate(this.calendarDate);
      });
    });
  },
  methods: {
    go360(row) {
      console.log(row);
      this.$router.push({
        path: "/worker360View",
        query: {
          workerNo: row.worker_no,
        },
      });
    },
    sortChange(e) {
      console.log(e);
    },
    BtnRefresh() {
      //刷新按钮
      this.getStationDashboardTrade();
      this.getStationDashboardDaily();
      this.getStationServiceRebuy();
      this.queryWorkerDetail();
    },
    queryWorkerDetail() {
      let x = this.queryString.postId;
      let req = {
        cityId: this.queryString.cityId == null ? "2" : this.queryString.cityId,
        postId: x,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      };
      if (req.postId === 0) {
        delete req.postId;
      }

      if (this.searchName) {
        req.searchName = this.searchName;
      }
      workercrmapi.$axiosManagerViewWorkerLifeIndicators(req).then((res) => {
        if (res.data.errno == 0) {
          this.listData = res.data.data.detail.list;
          this.total = res.data.data.detail.total;
        }
      });
    },
    getStationDashboardTrade() {
      //站长库存看板
      this.queryString.month = this.calendarMonth;
      workercrmapi
        .$axioGetStationDashboardTrade(this.queryString)
        .then((res) => {
          this.trades = res.data.data.trades;
          this.tradesInfo = res.data.data.tradesInfo;
          this.honour = res.data.data.honour;
        });
    },
    getStationDashboardDaily() {
      //站长工作台的日常内容
      this.queryString.month = this.calendarMonth;
      workercrmapi
        .$axioGetStationDashboardDaily(this.queryString)
        .then((res) => {
          this.daily = res.data.data;
          this.getDailyStock();
        });
    },
    getPostStationList() {
      console.log("this.globalData===>" + JSON.stringify(globalData));
      workercrmapi.$axiosGetAllPostStation({userId:globalData.userInfo.id}).then((res) => {
        this.citys = res.data.data.city;
        this.postStation = res.data.data.postStation;
        this.station = res.data.data.station;

        this.cityChange(this.queryString.city);
        this.getStationDashboardTrade();
      });
    },
    getStationServiceRebuy() {
      //服务及复购数据
      this.listQueryServiceRebuy.city = this.queryString.city;
      this.listQueryServiceRebuy.postId = this.queryString.postId;
      workercrmapi
        .$axioGetStationDashboardServiceRebuy(this.listQueryServiceRebuy)
        .then((res) => {
          this.serviceRebuy = res.data.data;
        });
    },
    handleTradeTabClick() {
      //点击了工单明细弹框中的tab
      if (this.tradeTab == "first") this.queryTradeByDay();
      else if (this.tradeTab == "second") this.querySuspendByDay();
    },
    calendarClick(date) {
      console.info(date);
      this.listQueryTrade.date = date;
      this.listQuerySuspend.date = date;
      this.dialogTradeFormVisible = true;
      this.tradeTab = "first";
      this.tradeListByDay = [];
      this.suspendListByDay = [];
      this.listQueryTrade.pageIndex = 1;
      this.listQuerySuspend.pageIndex = 1;
      this.queryTradeByDay();
    },
    queryTradeByDay() {
      //查询每日工单数量
      this.listQueryTrade.city = this.queryString.city;
      this.listQueryTrade.postId = this.queryString.postId;
      workercrmapi
        .$axioGetStationDashboardTradeByDay(this.listQueryTrade)
        .then((res) => {
          this.tradeListByDay = res.data.data.list;
          this.listQueryTrade.total = res.data.data.total;
        });
    },
    querySuspendByDay() {
      //查询每日挂单明细
      this.listQuerySuspend.city = this.queryString.city;
      this.listQuerySuspend.postId = this.queryString.postId;
      workercrmapi
        .$axioGetStationDashboardSuspendTradeByDay(this.listQueryTrade)
        .then((res) => {
          this.suspendListByDay = res.data.data.list;
          this.listQuerySuspend.total = res.data.data.total;
        });
    },
    filterDailyItem(name) {
      let items = this.daily.filter((item) => {
        return item.name == name;
      });
      if (items != null && items.length > 0) return items[0].value;
      return "0";
    },
    getDailyStock() {
      //获取库存剩余率
      let stock = this.filterDailyItem("7天库存");
      stock = stock.toString();
      if (stock != "0") {
        if (stock.length == 1) this.stock7 = [0, stock[0]];
        else if (stock.length == 2) this.stock7 = [stock[0], stock[1]];
      }
      stock = this.filterDailyItem("14天库存");
      stock = stock.toString();
      if (stock != "0") {
        if (stock.length == 1) this.stock14 = [0, stock[0]];
        else if (stock.length == 2) this.stock14 = [stock[0], stock[1]];
      }
    },
    cityChange(value) {
      let city = this.citys.filter((item) => {
        return item.city == value;
      });

      this.queryString.postId = "";
      this.cityPost = this.postStation.filter((item) => {
        return item.cityId == city[0].cityId;
      });
    },
    preMonth() {
      let prevBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(1)"
      );
      prevBtn.click();
    },
    nextMonth() {
      let nextBtn = document.querySelector(
        ".el-calendar__button-group .el-button-group>button:nth-child(3)"
      );
      nextBtn.click();
    },
    judgeDate(dateVal) {
      this.calendarMonth = formatDate(dateVal, "yyyy-MM");
      this.getStationDashboardTrade();
    },
    filterDate(date) {
      if (date > this.currDate) return "待履约";
      if (date == this.currDate) return "服务中";
      return "已完成";
    },
    formatDate(time, fmt) {
      if (time == null || typeof time == "undefined") return "";
      return formatDate(new Date(time), fmt);
    },
    filterHonour(label) {
      let list = [];
      this.honour.forEach((item) => {
        if (item.label === label) list.push(item);
      });
      return list;
    },
    formatSchDate(date) {
      let month = date.split("-")[1];
      let day = date.split("-")[2];
      return (
        parseInt(month).toString() + "月" + parseInt(day).toString() + "日"
      );
    },
  },
};
</script>


<style lang="scss" scoped>
.area {
  display: flex;
  margin: 10px;
}

.area .left3 {
  flex: 3;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
}

.area .left {
  flex: 4;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
}

.area .right {
  flex: 1;
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  margin-left: 10px;
}

.title {
  font-weight: 600;
  font-size: 16px;
  margin: 10px !important;
  text-align: center;
}

.time {
  float: right;
  color: #09afff;
}

.items {
  display: flex;
  margin-top: 5px;
}

.item {
  border-right: 1px solid #ddd;
  flex: 1;
}

.item .field {
  display: flex;
  margin: 10px;
}

.border_hiddle {
  border: 0px;
}

.item .label {
  color: #a7a3a3;
  text-align: left;
  flex: 2;
  font-size: 14px;
  margin-left: 20px;
}

.item .value {
  color: #41d0cd;
  text-align: center;
  flex: 1;
  font-size: 14px;
}

.item .labelC {
  text-align: center;
  flex: 2;
  margin-top: 5px;
  font-size: 13px;
}

.item .valueC {
  text-align: center;
  flex: 1;
  margin-top: 5px;
  font-size: 13px;
}

.item .desc {
  color: #41d0cd;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
}

[data-v-3925b587].content {
  overflow: hidden;
  text-align: center;
}

[data-v-3925b587].content {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

[data-v-3925b587] .center_text {
  position: absolute;
}

.el-calendar {
  margin-top: 10px;

  .el-calendar__header {
    //display: none !important;
  }
}

.el-calendar-table__row .current .el-calendar-day {
  color: #5c5151;
}

.el-calendar-table .el-calendar-day {
  height: 136px !important;
}

//.el-calendar-table__row .next {
//  display: none;
//}
//
//.el-calendar-table__row .prev .el-calendar-day {
//  display: none;
//}
.el-tabs__content {
  height: 550px;
  overflow-y: auto !important;
}

.pie_content {
  display: flex;
  flex-direction: column;
}

.pie_content span {
  color: #725d5d;
}

.bold {
  font-weight: 600;
}

.font12 {
  font-size: 12px;
}

.font13 {
  font-size: 13px;
  font-weight: 600;
}

.font12_b_mr {
  font-size: 12px;
  font-weight: 600;
  margin-right: 5px;
}

.font14_b_mr {
  font-size: 14px;
  font-weight: 600;
  margin-right: 5px;
}

.mt5 {
  margin-top: 5px;
}

.stock {
  align-items: center;
  flex-direction: row;
  justify-content: center;
  display: flex;
}

.center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.sche_board {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #94c494;
  padding: 5px 10px;
  font-size: 13px;
  width: 120px;
  color: white;
  margin-top: 10px;
  position: relative;
}

.question {
  position: absolute;
  top: 2px;
  right: 3px;
  background-color: #999;
  padding: 1px;
  border-radius: 50%;
  height: 15px;
  width: 15px;
  text-align: center;
  font-size: 11px;
}

.sche_title {
  text-align: left;
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 10px;
}

.sche_cell {
  display: flex;
  flex-direction: row;
  margin: 10px 0;
}

.sche_cell span {
  font-weight: 600;
  text-align: center;
  font-size: 11px;
  flex: 1;
}

.sche_cell_title {
  display: flex;
  flex-direction: row;
  margin: 12px 0;
}

.sche_cell_over {
  color: #c0c4cc;
}

.sche_cell_title span {
  font-weight: 600;
  text-align: center;
  font-size: 13px;
  flex: 1;
  line-height: 14px;
}

.stock div {
  padding: 5px;
  background-color: #09afff;
  border-radius: 3px;
  width: 32px;
  text-align: center;
  margin-left: 5px;
  color: #fff;
}

.flex_row {
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}

.flex_row_between {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.flex_row_between span {
  font-weight: 600;
}

.select {
  width: 76px;
  margin-left: 5px;
  margin-right: 10px;
}

.salary {
  margin-top: 20px;
  display: flex;
}

.salary img {
  width: 36px;
  height: 36px;
  margin-right: 10px;
}

.salary div {
  width: 100%;
}

.salary .line {
  height: 10px;
  margin-top: 5px;
  background-color: rgb(209, 201, 201);
}
</style>
